import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 32,
		cy: 32,
		r: 32,
		fill: "#FFEDCB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32.001 27.9998V33.3332M32.001 38.6665H32.0143M30.1547 21.1888L19.1882 40.1309C18.5799 41.1816 18.2758 41.7069 18.3208 42.1381C18.36 42.5141 18.557 42.8559 18.8628 43.0782C19.2134 43.3332 19.8204 43.3332 21.0345 43.3332H42.9675C44.1815 43.3332 44.7885 43.3332 45.1391 43.0782C45.445 42.8559 45.642 42.5141 45.6812 42.1381C45.7261 41.7069 45.422 41.1816 44.8137 40.1309L33.8472 21.1888C33.2411 20.1419 32.9381 19.6185 32.5427 19.4426C32.1978 19.2893 31.8041 19.2893 31.4592 19.4426C31.0639 19.6185 30.7608 20.1419 30.1547 21.1888Z",
		stroke: "#BF7109",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgAlertTriangle;
